module.exports = __webpack_public_path__ + "files/ef52c3202223c2b20b2ac0fa0a05103d.png";